import { render, staticRenderFns } from "./climate.vue?vue&type=template&id=63a9470e&scoped=true&"
import script from "./climate.vue?vue&type=script&lang=js&"
export * from "./climate.vue?vue&type=script&lang=js&"
import style0 from "./climate.vue?vue&type=style&index=0&id=63a9470e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a9470e",
  null
  
)

export default component.exports